import cronstrue from "cronstrue"
import { IServiceJob } from "@/models/admin/serviceJob/serviceJob.types"
import { sentenceCase } from "@/helpers/stringHelpers"

export class ServiceJob implements IServiceJob {
  constructor(
    public name: string,
    public cron: string | null,
  ) {}

  get nameDisplay(): string {
    return sentenceCase(this.name)
  }

  get cronDisplay(): string {
    return this.cron ?? "—"
  }

  get cronDescription(): string {
    if (!this.cron) return ""
    try {
      return cronstrue.toString(this.cron, { verbose: false })
    } catch {
      // Unparseable expression — show nothing rather than an error string.
      return ""
    }
  }
}
